import { combineReducers } from 'redux';
import { handleActions, combineActions } from 'redux-actions';
import * as actionTypes from './constants';

export const detectedLanguage = handleActions(
  {
    [actionTypes.DETECT_LANGUAGE_FAILURE]: () => ({}),
    [actionTypes.DETECT_LANGUAGE_SUCCESS]: (state, { payload }) => payload,
  },
  {},
);

export const translatedText = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_TRANSLATED_TEXT,
      actionTypes.FETCH_SUPPORTED_AZURE_LANGUAGES,
    )]: () => '',
    [combineActions(
      actionTypes.FETCH_TRANSLATED_TEXT_SUCCESS,
    )]: (state, { payload }) => payload.translatedText,
  },
  '',
);

export const translatorLanguages = handleActions(
  {
    [actionTypes.FETCH_SUPPORTED_AZURE_LANGUAGES]: () => [],
    [combineActions(
      actionTypes.FETCH_SUPPORTED_AZURE_LANGUAGES_SUCCESS,
    )]: (state, { payload }) => Object.keys(payload.translation)?.map(tk => ({
      key: tk,
      name: payload.translation[tk].name,
    })),
  },
  [],
);

export const isLoading = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_SUPPORTED_AZURE_LANGUAGES,
      actionTypes.FETCH_TRANSLATED_TEXT,
    )]: () => true,
    [combineActions(
      actionTypes.FETCH_SUPPORTED_AZURE_LANGUAGES_FAILURE,
      actionTypes.FETCH_SUPPORTED_AZURE_LANGUAGES_SUCCESS,
      actionTypes.FETCH_TRANSLATED_TEXT_SUCCESS,
      actionTypes.FETCH_TRANSLATED_TEXT_FAILURE,
    )]: () => false,
  },
  false,
);

export const isDetecting = handleActions(
  {
    [actionTypes.DETECT_LANGUAGE]: () => true,
    [combineActions(
      actionTypes.DETECT_LANGUAGE_FAILURE,
      actionTypes.DETECT_LANGUAGE_SUCCESS,
    )]: () => false,
  },
  false,
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.FETCH_SUPPORTED_AZURE_LANGUAGES,
      actionTypes.FETCH_SUPPORTED_AZURE_LANGUAGES_SUCCESS,
      actionTypes.FETCH_TRANSLATED_TEXT,
      actionTypes.FETCH_TRANSLATED_TEXT_SUCCESS,
      actionTypes.DETECT_LANGUAGE,
      actionTypes.DETECT_LANGUAGE_SUCCESS,
    )]: () => ({}),
    [combineActions(
      actionTypes.FETCH_SUPPORTED_AZURE_LANGUAGES_FAILURE,
      actionTypes.FETCH_TRANSLATED_TEXT_FAILURE,
      actionTypes.DETECT_LANGUAGE_FAILURE,
    )]: (state, { payload }) => payload.error,
  },
  {},
);

export default combineReducers({
  translatedText,
  translatorLanguages,
  isLoading,
  detectedLanguage,
  isDetecting,
  error,
});
